import { fetchOrLogout } from "../../../utils/helpers";
import { getBaseUrl } from "../../../utils/requestUtils";

export type MfaMethod = "email" | "otp";

export interface MfaStatusResponse {
  mfa_enabled: boolean;
  mfa_method: MfaMethod | null;
}

export interface MfaUpdateResponse extends MfaStatusResponse {
  force_logout: boolean;
}

export const GetMfaStatus = async (
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/mfa`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};

export const UpdateMfaStatus = async (
  data: { enabled: boolean; method?: MfaMethod },
  token: string,
  setLoggedOut: (inactivity: boolean) => void,
): Promise<Response> => {
  const baseUrl = await getBaseUrl();
  return fetchOrLogout(
    `${baseUrl}/api/v1/provider_portal/mfa`,
    {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    },
    setLoggedOut,
  );
};
